import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'pa-notice-dialog',
    templateUrl: './notice-dialog.component.html',
    styleUrls: ['./notice-dialog.component.scss'],
    standalone: false
})
export class NoticeDialogComponent implements OnDestroy {
  fileContent: string;
  onDestroy$ = new Subject<void>();
  constructor(
    private readonly http: HttpClient,
    private readonly dialogRef: MatDialogRef<NoticeDialogComponent>
  ) {
    this.http
      .get(environment.thirdPartyNoticesFileUrl, { responseType: 'text' })
      .subscribe({
        next: (data) => {
          this.fileContent = `View the third-party notice file to learn more about the external libraries, tools, or components used in this application. This document includes licensing information and acknowledgments required by third-party providers.\n\n`;
          this.fileContent += data
            .replace(/\\r\\n\\r\\n\\r\\n\\r\\n\\r\\n\\r\\n/, '')
            .replace(/\\n/g, '\n')
            .replace(/\\'/g, "'")
            .replace(/\\"/g, '"')
            .replace(/\\&/g, '&')
            .replace(/\\r/g, '\r')
            .replace(/\\t/g, '\t')
            .replace(/\\b/g, '\b')
            .replace(/\\f/g, '\f');
        },
        error: (error: HttpErrorResponse) => {
          this.dialogRef.close();
        }
      });
  }
  onCancelClick(): void {
    this.dialogRef.close();
  }
  
  ngOnDestroy() {
    this.onDestroy$.next();
  }
}
